import React from "react";
import useSEO from "./useSEO";

const Careers = () => {
  useSEO({
    title: "Careers | Join Our Team of Professionals",
    description:
      "Explore exciting career opportunities with us. Join a dynamic, growth-oriented team and build your future in a supportive and innovative work environment.",
    keywords:
      "careers, job openings, work with us, hiring now, career opportunities, join our team, employment opportunities, professional growth, job vacancies, recruitment",
    ogTitle: "Careers - Build Your Future With Us",
    ogDescription:
      "Discover career opportunities and become part of our talented team. Grow with us in an innovative and collaborative workplace.",
    ogImage: "img/careers.png",
    twitterTitle: "Careers - Build Your Future With Us",
    twitterDescription:
      "We’re hiring! Join our team and take the next step in your professional journey.",
    twitterImage: "img/careers.png",
  });

  return (
    <div>
      {/* ===== HERO SECTION ===== */}
      <section className="position-relative overflow-hidden pb-0 pt-xl-9">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Image */}
            <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
              <div className="pe-lg-6 pe-xl-8">
                <img
                  src="img/careers.png"
                  className="rounded shadow-sm"
                  alt="Careers"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="col-lg-6 ms-auto">
              <h2 className="mb-lg-4 fw-bold" style={{ fontSize: 35 }}>
                Careers
              </h2>
              <p>
                Join our team of dedicated professionals and be part of a
                growing organization that values integrity, innovation, and
                excellence. We’re looking for enthusiastic individuals ready to
                contribute and grow.
              </p>
              <hr className="my-4 my-lg-5" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== JOB OPENINGS SECTION ===== */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h3 className="fw-bold">Current Openings</h3>
            <p className="text-muted">
              Explore our latest career opportunities below.
            </p>
          </div>

          {/* JOB CARD */}
          <div className="card shadow-sm border-0 rounded-4 mb-4">
            <div className="card-body p-4">
              <h4 className="fw-semibold text-primary mb-3">
                Stock Audit Executives
              </h4>
              <ul className="list-unstyled mb-3">
                <li>
                  <strong>Location:</strong> Hyderabad, India
                </li>
                <li>
                  <strong>Experience:</strong> 0 – 3 years
                </li>
                <li>
                  <strong>Qualification:</strong> 10+2 / Graduate (Any Degree)
                </li>
                <li>
                  <strong>Openings:</strong> 3
                </li>
                <li>
                  <strong>Email:</strong>{" "}
                  <a href="mailto:ashok@elegantconsultings.com">
                    ashok@elegantconsultings.com
                  </a>
                </li>
              </ul>

              <h5 className="fw-bold mt-4">Job Description:</h5>
              <p>
                We are hiring 3 candidates for our Stock Audit team to assist in
                physical stock verification and inventory management. The role
                involves checking and reconciling stock records, identifying
                discrepancies, and preparing audit reports.
              </p>

              <h5 className="fw-bold mt-4">Key Responsibilities:</h5>
              <ul>
                <li>
                  Conduct physical stock audits at warehouses, retail outlets,
                  or client locations.
                </li>
                <li>Verify and reconcile stock records with system data.</li>
                <li>Identify discrepancies, shortages, or damages.</li>
                <li>Prepare and submit accurate audit reports.</li>
              </ul>

              <h5 className="fw-bold mt-4">Requirements:</h5>
              <ul>
                <li>
                  Qualification: 10+2 or any Degree (Commerce background
                  preferred but not mandatory).
                </li>
                <li>Experience: 0–3 years (freshers welcome).</li>
                <li>Good communication and basic computer skills.</li>
                <li>
                  Willingness to travel for audits if required.
                </li>
              </ul>
            </div>
          </div>

          {/* APPLY INFO */}
          <div className="text-center mt-4">
            <p className="fw-semibold">
              Interested candidates can send their resumes to{" "}
              <a
                href="mailto:ashok@elegantconsultings.com"
                className="text-decoration-none text-primary fw-bold"
              >
                ashok@elegantconsultings.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;
